"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { NgZone } from '@angular/core';
import { Actions, Effect, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { async } from 'rxjs/scheduler/async';
import { ApiHttp } from './api-http.service';
import { referencesEqual, uniq } from './helpers';
import { enterZone, leaveZone } from './zone-util';
function batch(requests) {
    var batches = {};
    var finishedBatches = [];
    requests.forEach(function (r) {
        if (r.ref.query) {
            finishedBatches = finishedBatches.concat([r]);
        }
        else if (batches[r.type] === undefined) {
            batches[r.type] = r;
        }
        else {
            var path = [
                r.ref.path[0],
                batches[r.type].ref.path[1] + "&" + r.ref.path[1],
            ];
            var payload = { type: r.type, ref: { path: path } };
            if (path[1].length > 1000) {
                finishedBatches = finishedBatches.concat([payload]);
                delete batches[r.type];
            }
            else {
                batches[r.type] = payload;
            }
        }
    });
    return finishedBatches.concat(Object.values(batches));
}
// TODO type refs/uniq back properly
var RequestDataEffect = (function () {
    function RequestDataEffect(apiHttp, actions, ngZone) {
        var _this = this;
        this.apiHttp = apiHttp;
        this.actions = actions;
        this.ngZone = ngZone;
        this.requestData = this.actions
            .ofType('REQUEST_DATA')
            .map(toPayload)
            .bufferTime(250, leaveZone(this.ngZone, async))
            .filter(function (requests) { return requests.length > 0; })
            .observeOn(enterZone(this.ngZone, async))
            .map(function (requests) {
            var uniqRequests = uniq(requests, function (a, b) {
                return referencesEqual(a.ref, b.ref);
            });
            return batch(uniqRequests);
        }) // TODO: https://github.com/ReactiveX/rxjs/issues/2759
            .mergeAll()
            .mergeMap(function (request) { return _this.apiHttp.fetch(request.ref); }, function (request, res) { return ({ res: res, request: request }); })
            .map(function (_a) {
            var res = _a.res, request = _a.request;
            switch (res.status) {
                case 'success': {
                    var action = {
                        type: 'API_FETCH_SUCCESS',
                        payload: {
                            type: request.ref.path[0],
                            result: res.result,
                            ref: request.ref,
                        },
                    };
                    return action;
                }
                case 'error': {
                    var action = {
                        type: 'API_FETCH_ERROR',
                        payload: {
                            type: request.ref.path[0],
                            message: res.message,
                            ref: request.ref,
                        },
                    };
                    return action;
                }
                default: {
                    var action = {
                        type: 'UNKNOWN_API_FETCH_ERROR',
                        payload: {
                            type: request.ref.path[0],
                            message: res,
                            ref: request.ref,
                        },
                    };
                    return action;
                }
            }
        });
    }
    RequestDataEffect.ctorParameters = function () { return [{ type: ApiHttp }, { type: Actions }, { type: NgZone }]; };
    __decorate([
        Effect(),
        __metadata("design:type", typeof (_a = typeof Observable !== "undefined" && Observable) === "function" && _a || Object)
    ], RequestDataEffect.prototype, "requestData", void 0);
    return RequestDataEffect;
    var _a;
}());
export { RequestDataEffect };
//# sourceMappingURL=request-data.effect.js.map


// WEBPACK FOOTER //
// request-data.effect.js